const TIME_OUT = 600000;
const BASE_URL = process.env.API_BASE_URL;

export { BASE_URL, TIME_OUT };
